export default {"src":"/_next/static/media/home-delivery.colour.e0c9149f.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};